<template>
  <div v-if="value.type == 'array'">
    <v-simple-table>
      <tbody>
        <tr v-for="item in value.items" :key="item.items">
          <td>
            <div
              :style="{
                backgroundColor: item.color,
              }"
              class="legent-item-color"
            ></div>
          </td>
          <td>{{ item.text }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
  <div v-else-if="value.type == 'linear-gradient'">
    <v-row no-gutters class="pl-4">
      <v-col cols="9">
        <div
          :style="{
            background: value.items[0].backgroundColor,
          }"
          class="legend-item-color"
        ></div>
      </v-col>
      <v-col cols="3" style="display: table; width: 100%">
        <div
          class="legend-value"
          style="display: table-cell; vertical-align: middle"
          >{{ value.items[0].value }}</div
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
    layer: { type: Object, default: () => ({}) },
  },
}
</script>
<style scoped>
.legent-item-color {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid lightgray;
}
.legend-item-color {
  width: 20px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid lightgray;
}
.legend-value {
  font-size: 0.875rem;
}
</style>
